



// import React, { useState } from 'react';
// import { ref, get } from 'firebase/database';
// import { database } from '../firebase';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';

// const AdminLogin = () => {
//   const [mobile, setMobile] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // Validate inputs
//       if (!mobile || !password) {
//         throw new Error('Both fields are required');
//       }

//       if (mobile.length !== 10 || !/^\d+$/.test(mobile)) {
//         throw new Error('Invalid mobile number');
//       }

//       // Check credentials against Firebase
//       const adminRef = ref(database, 'school/admin');
//       const snapshot = await get(adminRef);

//       if (snapshot.exists()) {
//         const adminData = snapshot.val();
        
//         if (adminData.mobile === mobile && adminData.password === password) {
//           toast.success('Login successful!');
//           localStorage.setItem('adminAuth', 'true');
//           navigate('/AdminDashboard');
//         } else {
//           throw new Error('Invalid credentials');
//         }
//       } else {
//         throw new Error('Admin credentials not found');
//       }
//     } catch (error) {
//       toast.error(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{
//       minHeight: '100vh',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
//     }}>
//       <div style={{
//         width: '100%',
//         maxWidth: '420px',
//         background: 'white',
//         borderRadius: '12px',
//         boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
//         overflow: 'hidden'
//       }}>
//         {/* Header */}
//         <div style={{
//           background: 'linear-gradient(to right, #3b82f6, #6366f1)',
//           padding: '28px',
//           textAlign: 'center',
//           color: 'white'
//         }}>
//           <h1 style={{
//             fontSize: '26px',
//             fontWeight: '600',
//             margin: '0 0 4px 0'
//           }}>Admin Portal</h1>
//           <p style={{
//             fontSize: '14px',
//             opacity: 0.9,
//             margin: 0
//           }}>Secure access to dashboard</p>
//         </div>

//         {/* Form */}
//         <div style={{ padding: '32px' }}>
//           <form onSubmit={handleLogin}>
//             {/* Mobile Input */}
//             <div style={{ marginBottom: '24px' }}>
//               <label htmlFor="mobile" style={{
//                 display: 'block',
//                 fontSize: '14px',
//                 fontWeight: '500',
//                 color: '#4b5563',
//                 marginBottom: '8px'
//               }}>Mobile Number</label>
//               <div style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 background: '#f9fafb',
//                 borderRadius: '8px',
//                 border: '1px solid #e5e7eb',
//                 overflow: 'hidden',
//                 transition: 'all 0.3s ease'
//               }}>
//                 <span style={{
//                   padding: '0 12px',
//                   color: '#6b7280',
//                   background: '#f3f4f6',
//                   height: '100%',
//                   display: 'flex',
//                   alignItems: 'center'
//                 }}>+91</span>
//                 <input
//                   type="tel"
//                   id="mobile"
//                   value={mobile}
//                   onChange={(e) => setMobile(e.target.value.replace(/\D/g, ''))}
//                   placeholder="8767086497"
//                   maxLength="10"
//                   style={{
//                     flex: 1,
//                     padding: '12px',
//                     border: 'none',
//                     background: 'transparent',
//                     outline: 'none',
//                     fontSize: '15px'
//                   }}
//                   required
//                 />
//               </div>
//             </div>

//             {/* Password Input */}
//             <div style={{ marginBottom: '32px' }}>
//               <label htmlFor="password" style={{
//                 display: 'block',
//                 fontSize: '14px',
//                 fontWeight: '500',
//                 color: '#4b5563',
//                 marginBottom: '8px'
//               }}>Password</label>
//               <input
//                 type="password"
//                 id="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="••••••••"
//                 style={{
//                   width: '100%',
//                   padding: '12px',
//                   borderRadius: '8px',
//                   border: '1px solid #e5e7eb',
//                   background: '#f9fafb',
//                   fontSize: '15px',
//                   outline: 'none',
//                   transition: 'all 0.3s ease',
//                   boxSizing: 'border-box'
//                 }}
//                 required
//               />
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={loading}
//               style={{
//                 width: '100%',
//                 padding: '14px',
//                 background: loading ? '#9ca3af' : 'linear-gradient(to right, #3b82f6, #6366f1)',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '8px',
//                 fontSize: '16px',
//                 fontWeight: '500',
//                 cursor: loading ? 'not-allowed' : 'pointer',
//                 transition: 'all 0.3s ease',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 boxShadow: '0 4px 6px rgba(59, 130, 246, 0.2)'
//               }}
//             >
//               {loading ? (
//                 <>
//                   <svg 
//                     style={{ 
//                       animation: 'spin 1s linear infinite',
//                       marginRight: '8px',
//                       width: '18px',
//                       height: '18px'
//                     }} 
//                     xmlns="http://www.w3.org/2000/svg" 
//                     fill="none" 
//                     viewBox="0 0 24 24"
//                   >
//                     <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Authenticating...
//                 </>
//               ) : 'Login to Dashboard'}
//             </button>
//           </form>
//         </div>

//         {/* Footer */}
//         <div style={{
//           padding: '16px',
//           textAlign: 'center',
//           fontSize: '12px',
//           color: '#6b7280',
//           borderTop: '1px solid #f3f4f6',
//           background: '#f9fafb'
//         }}>
//           <p>Secure access for authorized personnel only</p>
//         </div>
//       </div>

//       {/* Add spinner animation to global styles */}
//       <style>{`
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AdminLogin;























// src/components/AdminLogin.js
import React, { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../AuthContext';

const AdminLogin = () => {
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { auth, login } = useAuth();

  // Redirect if already logged in
  useEffect(() => {
    if (auth) {
      navigate('/AdminDashboard');
    }
  }, [auth, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate inputs
      if (!mobile || !password) {
        throw new Error('Both fields are required');
      }

      if (mobile.length !== 10 || !/^\d+$/.test(mobile)) {
        throw new Error('Invalid mobile number');
      }

      // Check credentials against Firebase
      const adminRef = ref(database, 'school/admin');
      const snapshot = await get(adminRef);

      if (snapshot.exists()) {
        const adminData = snapshot.val();
        
        if (adminData.mobile === mobile && adminData.password === password) {
          toast.success('Login successful!');
          
          // Generate token with expiration (7 days)
          const token = {
            value: Math.random().toString(36).substring(2) + Date.now().toString(36),
            expires: Date.now() + 7 * 24 * 60 * 60 * 1000 // 7 days
          };
          
          login(token);
          navigate('/AdminDashboard');
        } else {
          throw new Error('Invalid credentials');
        }
      } else {
        throw new Error('Admin credentials not found');
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Don't render if already authenticated
  if (auth) {
    return null;
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '420px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(to right, #3b82f6, #6366f1)',
          padding: '28px',
          textAlign: 'center',
          color: 'white'
        }}>
          <h1 style={{
            fontSize: '26px',
            fontWeight: '600',
            margin: '0 0 4px 0'
          }}>Admin Portal</h1>
          <p style={{
            fontSize: '14px',
            opacity: 0.9,
            margin: 0
          }}>Secure access to dashboard</p>
        </div>

        {/* Form */}
        <div style={{ padding: '32px' }}>
          <form onSubmit={handleLogin}>
            {/* Mobile Input */}
            <div style={{ marginBottom: '24px' }}>
              <label htmlFor="mobile" style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4b5563',
                marginBottom: '8px'
              }}>Mobile Number</label>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                background: '#f9fafb',
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                overflow: 'hidden',
                transition: 'all 0.3s ease'
              }}>
                <span style={{
                  padding: '0 12px',
                  color: '#6b7280',
                  background: '#f3f4f6',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}>+91</span>
                <input
                  type="tel"
                  id="mobile"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ''))}
                  placeholder="8767086497"
                  maxLength="10"
                  style={{
                    flex: 1,
                    padding: '12px',
                    border: 'none',
                    background: 'transparent',
                    outline: 'none',
                    fontSize: '15px'
                  }}
                  required
                />
              </div>
            </div>

            {/* Password Input */}
            <div style={{ marginBottom: '32px' }}>
              <label htmlFor="password" style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#4b5563',
                marginBottom: '8px'
              }}>Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  background: '#f9fafb',
                  fontSize: '15px',
                  outline: 'none',
                  transition: 'all 0.3s ease',
                  boxSizing: 'border-box'
                }}
                required
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                background: loading ? '#9ca3af' : 'linear-gradient(to right, #3b82f6, #6366f1)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 6px rgba(59, 130, 246, 0.2)'
              }}
            >
              {loading ? (
                <>
                  <svg 
                    style={{ 
                      animation: 'spin 1s linear infinite',
                      marginRight: '8px',
                      width: '18px',
                      height: '18px'
                    }} 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 24 24"
                  >
                    <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Authenticating...
                </>
              ) : 'Login to Dashboard'}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px',
          textAlign: 'center',
          fontSize: '12px',
          color: '#6b7280',
          borderTop: '1px solid #f3f4f6',
          background: '#f9fafb'
        }}>
          <p>Secure access for authorized personnel only</p>
        </div>
      </div>

      {/* Add spinner animation to global styles */}
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default AdminLogin;